import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import ContractedPlan from '../ContractedPlan';
import BarChart from '../../juristec-ui/core/BarChart';
import PieChart from '../../juristec-ui/core/PieChart';

import {
  InstanceInfoContainer,
  MainContainer,
  InstanceCardsRow,
  InstanceCardsScroll,
  ChartCard,
  OverflowContainer,
} from './styled/InstanceView.styled';

const defaultProps = {
  users: [],
  usersRolesQty: {
    supers: 0,
    scientists: 0,
    guests: 0,
  },
  planInfo: [],
  dashboardsQty: 0,
  memoryInfo: {
    used: 0,
    max: 0,
  },
  openPlans: () => {},
};

const InstanceView = ({
  users = defaultProps.users,
  usersRolesQty = defaultProps.usersRolesQty,
  memoryInfo = defaultProps.memoryInfo,
  dashboardsQty = defaultProps.dashboardsQty,
  planInfo = defaultProps.planInfo,
  openPlans = defaultProps.openPlans,
}) => {
  const theme = useTheme();
  const usersChart = [
    { label: 'Proprietário', value: usersRolesQty.supers },
    { label: 'Cientista', value: usersRolesQty.scientists },
    { label: 'Convidado', value: usersRolesQty.guests },
  ];

  const usersColors = {
    Proprietário: '#286EE6',
    Cientista: '#11AA62',
    Convidado: '#FF0000',
  };

  const memoryChart = () => {
    const memoryDash = dashboardsQty * 10;
    const memoryFiles = memoryInfo.used - memoryDash;
    const memoryFree = memoryInfo.max - memoryDash - memoryFiles;
    return [
      { label: 'Dashboards', value: memoryDash.toFixed(2) },
      { label: 'Arquivos', value: memoryFiles.toFixed(2) },
      { label: 'Livre', value: memoryFree.toFixed(2) },
    ];
  };

  const memoryColors = {
    Dashboards: '#FF9626',
    Arquivos: '#4711B2',
    Livre: '#d3d1d1',
  };

  const chartStyle = {
    sliceThickness: 2,
    margin: 5,
    fontSize: 20,
    fontColor: theme.color,
  };

  const legendStyle = {
    size: 15,
    spacing: 35,
    position: 'bottom',
    shape: 'square',
    fontColor: theme.color,
  };

  return (
    <MainContainer>
      <InstanceInfoContainer>
        <div className="column-small">
          <ContractedPlan planInfo={planInfo} openPlans={openPlans} />
        </div>
        <div className="column-large">
          <InstanceCardsScroll>
            <InstanceCardsRow>
              <ChartCard>
                <h3>Usuários</h3>
                <div style={{ width: '100%', height: '100%' }}>
                  <PieChart
                    data={usersChart}
                    result={[{
                      label: 'Usuários',
                      value:
                        parseInt(usersRolesQty.supers, 10)
                        + parseInt(usersRolesQty.scientists, 10)
                        + parseInt(usersRolesQty.guests, 10),
                    }]}
                    dataColors={usersColors}
                    chartStyle={chartStyle}
                    legendStyle={legendStyle}
                  />
                </div>
                {/* <div>
                  <Button
                    color="primary"
                    variant="outlined"
                    size="large"
                    style={{ marginTop: '.5rem' }}
                    onClick={() => solicitationModal('users')}
                  >
                    Adicionar
                  </Button>
                </div> */}
              </ChartCard>
              <ChartCard>
                <h3>Espaço em Disco</h3>
                <div style={{ width: '100%', height: '100%' }}>
                  <PieChart
                    data={memoryChart()}
                    result={[{
                      label: 'Utilizado',
                      value: `${((memoryInfo.used * 100) / memoryInfo.max).toFixed()}%`,
                    }]}
                    dataColors={memoryColors}
                    chartStyle={chartStyle}
                    legendStyle={legendStyle}
                  />
                </div>
                {/* <div>
                  <Button
                    color="primary"
                    variant="outlined"
                    size="large"
                    style={{ marginTop: '.5rem' }}
                    onClick={() => solicitationModal('memory')}
                  >
                    Adicionar
                  </Button>
                </div> */}
              </ChartCard>
            </InstanceCardsRow>
            <InstanceCardsRow>
              <ChartCard>
                <h3>Dashboards por usuário</h3>
                <OverflowContainer>
                  <BarChart
                    data={users.map((u, i) => ({
                      index: i,
                      label: u.name,
                      value: u.nr_dashboards,
                    }))}
                  />
                </OverflowContainer>
              </ChartCard>
            </InstanceCardsRow>
          </InstanceCardsScroll>
        </div>
      </InstanceInfoContainer>
    </MainContainer>
  );
};

InstanceView.propTypes = {
  /**
   * Array with the data of the users
   */
  users: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  /**
   * Memory quantity info of the instance
   */
  memoryInfo: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({
      used: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      max: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    }),
  ]),
  /**
   * Dashboards quantity info of the instance
   */
  dashboardsQty: PropTypes.number,
  usersRolesQty: PropTypes.shape({
    /**
     * Quantity of users with the role of scientist
     */
    scientists: PropTypes.number,
    /**
     * Quantity of users with the role of guest
     */
    guests: PropTypes.number,
    /**
     * Quantity of users with the role of super
     */
    supers: PropTypes.number,
  }),
  /**
   * A function to request the addition of more users or memory
   */
  planInfo: PropTypes.arrayOf(PropTypes.shape({})),
  /**
   * Function to open the plans modal
   */
  openPlans: PropTypes.func,
};

export default InstanceView;
